// extracted by mini-css-extract-plugin
module.exports = {"App":"RandomPage_App__2AP9I","ButtonContainer":"RandomPage_ButtonContainer__68Ksf","Button":"RandomPage_Button__3ruoQ","Title":"RandomPage_Title__yf2uz"};